import React from 'react';
import { Buttons, Wrapper, Bar } from './css';
const getDots = (length, active, onClickHandler, positionindicatorCss, isNewTemplate) => {
    const dots = [];
    for (let i = 0; i < length; i += 1) {
        const isActive = (i === active);
        dots.push(React.createElement(Wrapper, { key: `dotWrap${i}`, isNewTemplate: isNewTemplate, positionindicatorCss: positionindicatorCss, className: `${isActive ? 'active' : ''}`, onClick: () => onClickHandler(i) },
            React.createElement(Buttons, { isNewTemplate: isNewTemplate, positionindicatorCss: positionindicatorCss, "aria-label": `${i}` })));
    }
    return dots;
};
const Dots = ({ length, active, onClickHandler, positionindicatorCss, isNewTemplate, }) => {
    if (length <= 1) {
        return null;
    }
    return (React.createElement(Bar, { isNewTemplate: isNewTemplate, positionindicatorCss: positionindicatorCss }, getDots(length, active, onClickHandler, positionindicatorCss, isNewTemplate)));
};
export default Dots;
